import { createContext, useContext } from 'react'

import { useAuth } from '../../Shared/Contexts/AuthContext'

const RolesContext = createContext({})

export const useRoles = () => {
  return useContext(RolesContext)
}

export const RolesProvider = ({ children }) => {
  const { useBaseAxiosGet, useBaseAxiosPost, useBaseAxiosPut } = useAuth()

  const useFetchRolesStandardQuery = async () => {
    return await useBaseAxiosGet({ url: 'roles/standard' })
  }

  const useCreateRoleStandardQuery = async (payload) => {
    return await useBaseAxiosPost({
      url: 'roles/standard',
      payload: {
        name: payload.name,
        permissions: payload.permissions,
        isPublic: true
      }
    })
  }

  const useEditRoleStandard = async ({ name, payload }) => await useBaseAxiosPut({
    url: `roles/standard/${name}`,
    payload: {
      permissions: payload.permissions
    }
  })

  const useFetchRolesSuperQuery = async () => await useBaseAxiosGet({ url: 'roles/super' })
  
  const value = {
    useFetchRolesStandardQuery,
    useCreateRoleStandardQuery,
    useFetchRolesSuperQuery,
    useEditRoleStandard
  }

  return <RolesContext.Provider value={value}>{children}</RolesContext.Provider>
}
